import './SlackAuthUrl.scss';
import { CopyText } from '@ui/text';
import { integrationsActions } from '@sonar-software/sonar-integrations';
import React from 'react';
import { SonarCard } from '@ui/general';
import { When } from 'react-if';
import { Button, Form, Typography } from 'antd';
import { COPY_SPECIFIC, INTEGRATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors, createSonarSelector } from '@lib/selectors';
import { useAction, useSonarSelector } from '@hooks';
const getSlackAuthUrlSelectors = createAsyncSelectors((state) => state.integrations.slack.get);
const slackAuthUrlSelector = createSonarSelector((state) => { var _a; return (_a = getSlackAuthUrlSelectors.data(state)) === null || _a === void 0 ? void 0 : _a.link; });
export const SlackAuthUrl = () => {
    var _a;
    const requestSlackAuthLink = useAction(integrationsActions.requestGetSlackAuthLink);
    const isRequested = useSonarSelector(getSlackAuthUrlSelectors.isRequested);
    const authLink = (_a = useSonarSelector(slackAuthUrlSelector)) !== null && _a !== void 0 ? _a : '';
    return (React.createElement(SonarCard, { className: 'slack-auth', id: 'slack-auth', title: COPY_SPECIFIC.SLACK_URL },
        React.createElement(Form, { name: 'slack-url' },
            React.createElement(Typography, null, INTEGRATIONS_COPY.GENERATE_SLACK_LINK),
            React.createElement(Button, { className: 'slack-link-button', disabled: isRequested, id: 'generate-slack-auth-url', onClick: () => requestSlackAuthLink(), type: 'primary' }, COPY_SPECIFIC.GENERATE_LINK),
            React.createElement(When, { condition: authLink },
                React.createElement(CopyText, { text: authLink })))));
};
